import {consoleNoop, ResponsiveBreakpoint, ieShims} from "./common";
import {extendJQuery} from "./include/JQueryExtensions";
import {EventEmitter} from "events";

class StateHolder {
  constructor() {
    this._vault = {};
  }
  exists(name) {
    return typeof this._vault[name] !== "undefined";
  }
  get(name) {
    return typeof this._vault[name] !== "undefined" ? this._vault[name] : null;
  }
  set(name, value) {
    this._vault[name] = value;
    return this;
  }
  remove(name) {
    if (this.exists(name)) delete this._vault[name];
    return this;
  }
}

let blockNum = 0
function nextBlockName() {
  return `block-${++blockNum}`
}

/**
 * Definition for global singleton manager object
 */
class Theme extends EventEmitter {
  constructor() {
    super();
    ieShims();
    extendJQuery();
    this.state = new StateHolder();
    this._debug = false;
    this.console = consoleNoop;
    
    this._blockDefinitions = new Map();
    this._breakpoints = new Map();
    this._plugins = new Map();
    
    this.root = $("#site-root");
    this.body = $(document.body);
    
    this.environment = window.ModularThemeClient;
  }
  
  /**
   * @param {class} classDefinition
   * @param {string|Node} rootSelector
   * @param {string} name
   * @returns {BlockDefinition}
   */
  registerBlock(classDefinition, rootSelector, name = "") {
    // This was VERY BAD IDEA in retrospect
    // let blockName = classDefinition.name;
    // if (!blockName) {
    //   let matches = classDefinition.toString().match(/^\s*function\s+([^\(\s]*)\s*/);
    //   blockName = name !== "" ? name : matches[1];
    // }
    let def = BlockDefinition.create(classDefinition, rootSelector, nextBlockName());
    this.addBlockDefinition(def);
    return def;
  }
  
  /**
   *
   * @param {BlockDefinition} blockDefinition
   * @returns {Theme}
   */
  addBlockDefinition(blockDefinition) {
    this._blockDefinitions.set(blockDefinition.name, blockDefinition);
    return this;
  }
  
  /**
   * Starts theme initialization
   * @returns {Theme}
   */
  init() {
    this.emit("Theme.init::start");
    this._blockDefinitions.forEach(blockDef => {
      let blocks = BaseBlock.createFromDefinition(blockDef);
      if (!blocks) return false;
      this.console.log(`%c'${blockDef.name}'`, "color: Aquamarine");
      blocks.forEach(b => this.console.log(b));
    });
    this.console.log("\n%cTheme initialized", "color: #9a9a9a; font-size: 1.2em");
    this.console.log(this);
    this.emit("Theme.init::end");
    return this;
  }
  
  registerPlugin(name, classDefinition) {
    this._plugins.set(name, new classDefinition());
    return this;
  }
  
  plugin(name) {
    return this._plugins.has(name) ? this._plugins.get(name) : false;
  }
  
  debug() { return this._debug; }
  
  /**
   * Turn debug mode ON or OFF
   * @param {boolean} turnOn
   */
  setDebug(turnOn = false) {
    this._debug = turnOn;
    this.console = turnOn ? window.console : consoleNoop;
    if (turnOn) window.theme = this;
  }
  
  addBreakpoint(name, width, height) {
    this._breakpoints.set(name, new ResponsiveBreakpoint(width, height));
    return this;
  }
  
  breakpoint(name) {
    return this._breakpoints.get(name);
  }
  
  /**
   * Check if current device is touch enabled
   * @returns {boolean}
   */
  isTouchDevice() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }
  
  /**
   * Wrapper around jQuery.ajax method, adopted to work with backend controllers.
   * This method makes use of 'multipart/form-data' content type,
   * allowing to pass complex data via FormData interface
   *
   * @param {string}          controller Controller name
   * @param {string?}         handler    Controller handler name
   * @param {object|FormData} payload    Data to pass to the handler. Note that "action" property is used by wordpress and will be overridden.
   * @param callbacks
   * @param {object?}         args       Additional arguments for jQuery.ajax call. 'method', 'url' and 'data' are ignored
   *
   * @returns {jqXHR} jQuery XHR object
   */
  request(controller, handler, payload = new FormData(), callbacks = {}, args = {}) {
    let data = new FormData();
    
    if (payload instanceof FormData) {
      data = payload;
    } else if (payload instanceof Object) {
      for (let prop in payload) {
        if (payload.hasOwnProperty(prop)) {
          data.append(prop, payload[prop]);
        }
      }
    } else {
      throw new Error("Illigal payload type provided");
    }
    
    data.append("action", controller);
    data.append("__handler", handler || "defaultTask");
    
    let defaults = {
      method: "POST",
      url: this.environment.ajaxurl,
      data: data,
      processData: false,
      contentType: false,
      mimeType: false,
      cache: false,
    };
    
    let request = $.ajax($.extend(args, defaults));
    
    request.always((data, status, jqXHR) => {
      if (typeof callbacks.complete === "function") callbacks.complete(data.payload, status, jqXHR);
      if (status !== "success" || !data || data.success !== "true") {
        this.console.warn("Request failed", data);
        if (typeof callbacks.fail === "function") callbacks.fail(data.payload, status, jqXHR);
      } else {
        if (typeof callbacks.success === "function") callbacks.success(data.payload, status, jqXHR);
      }
    });
    return request;
  }
}

const theTheme = new Theme();
export const theme = theTheme;



export class MarkupPlugin {
  constructor() {
    /**
     * jQuery selector that defines elements that will be processed
     * @type {string}
     */
    this._triggerSelector = ".theme-plugin";
    theme.on("Theme.init::end", () => {
      this.init();
    });
  }
  
  init() {}
  
  /**
   * Set CSS selector for elements that should be affected by MarkupPlugin
   * @param {string} name
   * @returns {Plugin}
   */
  setTriggerSelector(name) {
    this._triggerSelector = name;
    return this;
  }
}


export class EventAggregator {
  constructor() {
    this.__listeners = new Map();
  }
  
  /**
   * Add event listener
   * @param {string} type
   * @param listener
   * @return {EventAggregator}
   */
  listenFor(type, listener) {
    if (!this.__listeners.has(type)) this.__listeners.set(type, []);
    this.__listeners.get(type).push(listener);
    return this;
  }
  
  /**
   * Remove existing listener
   * @param {string} type
   * @param listener
   * @returns {*}
   */
  removeListener(type, listener) {
    if (!this.__listeners.has(type)) return false;
    
    let listeners = this.__listeners.get(type);
    
    return listeners.reduce((res, storedListener, i) => {
      if (listener === storedListener) {
        listeners.splice(i, 1);
        return true;
      }
      return false;
    }, false);
  }
  
  /**
   * Notify listeners of actions
   * @param {string} type
   * @param args
   * @returns {EventAggregator}
   */
  notify(type, ...args) {
    if (!this.__listeners.has(type)) return this;
    
    let listeners = this.__listeners.get(type);
    
    args.unshift(type);
    listeners.forEach(listener => listener.apply(null, args));
    return this;
  }
}


/**
 * Base class for all blocks in applications
 */
export class BaseBlock extends EventAggregator {
  /**
   *
   * @param {jQuery} root
   */
  constructor(root) {
    super();
    this.root = root;
    this.console = theme.debug() ? window.console : consoleNoop;
  }
  
  /**
   * @param {BlockDefinition} blockDefinition
   */
  static createFromDefinition(blockDefinition) {
    let roots = jQuery(blockDefinition.getRootSelector());
    if (roots.length) {
      return roots.toArray().map(root => {
        let block = blockDefinition.createInstance($(root));
        blockDefinition.addBlock(block);
        return block;
      });
    } else {
      return false;
    }
  }
}

/**
 * Definition of each Block type
 */
export class BlockDefinition {
  constructor(classDefinition, rootSelector, name) {
    this.name = name;
    this.rootSelector = rootSelector;
    this.class = classDefinition;
    this.blocks = [];
  }
  
  /**
   * @param {class} classDefinition
   * @param {string} rootSelector
   * @param {string} name
   * @returns {BlockDefinition}
   */
  static create(classDefinition, rootSelector, name) {
    return new BlockDefinition(classDefinition, rootSelector, name);
  }
  
  getName() { return this.name; }
  getBlocks() { return this.blocks; }
  getRootSelector() { return this.rootSelector; }
  
  createInstance(root) {
    return new this.class(root, this);
  }
  
  addBlock(block) { this.blocks.push(block); }
}
